import {
  BundleModelFactory,
  BundleSharedModelFactory,
  UserModelFactory,
  BundleDTOModelFactory,
  CollectionModelFactory,
} from 'monocle-models'

import { Timestamp } from 'firebase/firestore'
import { z } from 'zod'
import type { PropType } from 'vue'

const { BundleDBModel, bundleConverter, BundleHolder } = new BundleModelFactory(
  Timestamp,
)
const { CollectionDBModel, collectionConverter } = new CollectionModelFactory(
  Timestamp,
)

const { canAccess, isLapsed } = UserModelFactory
const { UserDBModel, userConverter } = new UserModelFactory(Timestamp)

export type BundleProp = z.infer<typeof BundleDBModel>
export type BundleListProp = Array<BundleProp>
export type UserProp = z.infer<typeof UserDBModel>

export type BundleObjectProp = PropType<BundleProp>
export type BundleListArrayProp = PropType<BundleListProp>
export type UserObjectProp = PropType<UserProp>

export default function () {
  const { BundleCreateDto, BundleResponseDto, BundleFileMetadataDto } =
    new BundleDTOModelFactory(Timestamp)
  const { BundleDBModel, bundleConverter, BundleHolder } =
    new BundleModelFactory(Timestamp)
  const { BundleSharedDBModel, sharedBundleConverter } =
    new BundleSharedModelFactory(Timestamp)
  const { CollectionDBModel, collectionConverter } = new CollectionModelFactory(
    Timestamp,
  )

  return {
    BundleDBModel,
    BundleHolder,
    bundleConverter,
    BundleSharedDBModel,
    sharedBundleConverter,
    CollectionDBModel,
    collectionConverter,
    UserDBModel,
    userConverter,
    BundleCreateDto,
    BundleResponseDto,
    BundleFileMetadataDto,

    canAccess,
    isLapsed,
  }
}
